import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { FixedSizeList as List } from 'react-window'
import useSyncScroll from 'utils/useSyncScroll'

import RevenueWebsiteTableHeader from './RevenueWebsiteTableHeader'
import RevenueWebsiteTableRow from './RevenueWebsiteTableRow'

const RevenueWebsiteTable = ({
  dataSourceVisibility,
  headerClassName,
  itemHeight,
  listHeight,
  maxRevenue,
  onFilter,
  onScroll,
  scrollOffset,
  showModal,
  sortBy,
  stores,
  totalRevenue,
  type,
}) => {
  const listRef = useRef()

  useSyncScroll(listRef, scrollOffset)

  return (
    <div className="revenue-table">
      <RevenueWebsiteTableHeader
        className={headerClassName}
        dataSourceVisibility={dataSourceVisibility}
        onFilter={onFilter}
        sortBy={sortBy}
        type={type}
      />

      <List
        useIsScrolling
        className="revenue-website-table-row"
        height={listHeight}
        itemCount={stores.length}
        itemData={{
          dataSourceVisibility,
          maxRevenue,
          showModal,
          stores,
          totalRevenue,
          type,
        }}
        itemSize={itemHeight}
        onScroll={onScroll}
        overscanCount={8}
        ref={listRef}
        width="100%"
      >
        {RevenueWebsiteTableRow}
      </List>
    </div>
  )
}

RevenueWebsiteTable.propTypes = {
  dataSourceVisibility: PropTypes.bool,
  headerClassName: PropTypes.string,
  itemHeight: PropTypes.number,
  listHeight: PropTypes.number,
  maxRevenue: PropTypes.number,
  onFilter: PropTypes.func,
  onScroll: PropTypes.func,
  scrollOffset: PropTypes.number,
  showModal: PropTypes.func,
  sortBy: PropTypes.object,
  stores: PropTypes.array,
  totalRevenue: PropTypes.number,
  type: PropTypes.string,
}

export default RevenueWebsiteTable
